import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoginService } from '../login/login.service';
import { urls } from 'assets/url/urls';

@Injectable({
  providedIn: 'root'
})
export class HolidayService {
  private readonly PREV_YEARS: number = 1
  private readonly MIN_YEARS: number = 5

  private readonly REST_API_SERVER = `${urls.baseUrl}/holiday`
  private readonly HEADERS = new HttpHeaders({
    'X-TENANT-ID': urls.tenant,
    'Authorization': 'Bearer ' + this.loginService.getToken()
  })

  /**
   * Constructor
   *
   * @param {HttpClient} http
   * @param {LoginService} loginService
   * 
  */
  constructor(
    private http: HttpClient,
    private loginService: LoginService
  ) { }

  public getHolidays(year: number = new Date().getFullYear()): Observable<string[]> {
    const headers = this.HEADERS

    return this.http.get<string[]>(`${this.REST_API_SERVER}/${year}`, { headers })
  }

  public getAllHolidaysFromYears(years: number[]): Observable<string[]> {
    const headers = this.HEADERS

    return this.http.post<string[]>(`${this.REST_API_SERVER}`, years, { headers })
  }

  public getStartYearForHolidays(): number[] {
    const now = new Date()
    const startYear = now.getFullYear() - this.PREV_YEARS

    return Array.from({ length: this.MIN_YEARS }, (_, i) => startYear + i)
  }
}